/**
 * Uzbek (uz-Latn) — the default locale and the source of truth for message keys.
 *
 * Business terms follow the glossary in SPEC.md §2: kirim, chiqim, partiya, qoldiq, kontragent.
 * Translators change `ru.ts` and `en.ts`; keys are only ever added here first.
 */
export default {
  app: {
    name: 'Ombor',
    tagline: 'Ombor va distribyutsiya tizimi',
  },
  common: {
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    create: 'Yaratish',
    edit: 'Tahrirlash',
    delete: 'Oʻchirish',
    deleteConfirm:
      '«{name}» oʻchirilsinmi? Yozuv roʻyxatlardan chiqadi, hujjatlari tarixda qoladi.',
    search: 'Qidirish',
    loading: 'Yuklanmoqda…',
    unsavedWarning: 'Saqlanmagan oʻzgarishlar bor. Sahifadan chiqasizmi?',
    draftFound: 'Saqlanmagan qoralama topildi.',
    restoreDraft: 'Tiklash',
    discardDraft: 'Oʻchirish',
    print: 'Chop etish',
    undo: 'Qaytarish',
    retry: 'Qayta urinish',
    close: 'Yopish',
    yes: 'Ha',
    no: 'Yoʻq',
    actions: 'Amallar',
    active: 'Faol',
    inactive: 'Nofaol',
    never: 'Hech qachon',
    back: 'Orqaga',
    of: 'dan',
    total: 'Jami',
    post: 'Tasdiqlash',
    confirm: 'Tasdiqlash',
    cancelDocument: 'Bekor qilish',
    reason: 'Sabab',
    note: 'Izoh',
    moreResults: 'Yana {count} ta — aniqroq yozing',
    daysShort: '{n} kun',
    leave: 'Chiqib ketish',
  },
  nav: {
    dashboard: 'Bosh sahifa',
    warehouse: 'Ombor',
    receipts: 'Kirim',
    shipments: 'Chiqim',
    stock: 'Qoldiqlar',
    suppliers: 'Yetkazib beruvchilar',
    agents: 'Agentlar',
    stores: 'Magazinlar',
    payments: 'Kassa',
    reports: 'Hisobotlar',
    settings: 'Sozlamalar',
    users: 'Foydalanuvchilar',
    sessions: 'Sessiyalar',
    main: 'Asosiy menyu',
    collapse: 'Menyuni yigʻish',
    expand: 'Menyuni yoyish',
    search: 'Qidirish',
    kassa: 'Kassa',
    logout: 'Chiqish',
    theme: 'Mavzu',
    language: 'Til',
  },
  auth: {
    loginTitle: 'Tizimga kirish',
    loginSubtitle: 'Hisobingizga kiring',
    username: 'Login',
    password: 'Parol',
    rememberMe: 'Meni eslab qol',
    submit: 'Kirish',
    submitting: 'Kirilmoqda…',
    loggedInAs: 'Kirgan foydalanuvchi',
    changePassword: 'Parolni oʻzgartirish',
    currentPassword: 'Joriy parol',
    newPassword: 'Yangi parol',
    confirmPassword: 'Yangi parolni takrorlang',
    passwordChanged: 'Parol oʻzgartirildi. Qaytadan kiring.',
    mustChangePassword: 'Xavfsizlik uchun parolingizni oʻzgartiring.',
    lockedUntil: 'Hisob {time} gacha bloklangan.',
    logoutAll: 'Barcha qurilmalardan chiqish',
    sessionsTitle: 'Faol sessiyalar',
    currentSession: 'Joriy qurilma',
    revokeSession: 'Sessiyani tugatish',
    lastSeen: 'Boshlangan',
    expiresAt: 'Tugaydi',
    device: 'Qurilma',
    ipAddress: 'IP manzil',
    revokeConfirm: 'Bu sessiya tugatilsinmi? Oʻsha qurilmada qaytadan kirish kerak boʻladi.',
    usernameRequired: 'Loginni kiriting',
    passwordRequired: 'Parolni kiriting',
  },
  users: {
    title: 'Foydalanuvchilar',
    create: 'Yangi foydalanuvchi',
    edit: 'Foydalanuvchini tahrirlash',
    fullName: 'F.I.O.',
    phone: 'Telefon',
    role: 'Rol',
    phoneHint: 'Telegram bot shu raqam boʻyicha taniydi. Raqamsiz odam botga kira olmaydi.',
    noPhone: 'raqam yoʻq',
    noPhoneWhy: 'Bu odam Telegram botga kira olmaydi — raqam kiritilmagan.',
    status: 'Holat',
    lastLogin: 'Oxirgi kirish',
    resetPassword: 'Parolni tiklash',
    resetPasswordHint:
      'Yangi parol beriladi va foydalanuvchining barcha sessiyalari tugatiladi. U birinchi kirishda parolni oʻzgartirishi shart boʻladi.',
    deactivate: 'Nofaol qilish',
    deactivateConfirm: '«{name}» nofaol qilinsinmi? U tizimga kira olmay qoladi.',
    activate: 'Faollashtirish',
    created: 'Foydalanuvchi yaratildi',
    updated: 'Foydalanuvchi yangilandi',
    passwordReset: 'Parol tiklandi. {count} ta sessiya tugatildi.',
    empty: 'Foydalanuvchilar topilmadi.',
    searchPlaceholder: 'Login yoki F.I.O. boʻyicha qidirish',
  },
  roles: {
    ADMIN: 'Direktor',
    MANAGER: 'Menejer',
    STOREKEEPER: 'Omborchi',
    ACCOUNTANT: 'Hisobchi',
    AGENT: 'Agent',
    VIEWER: 'Kuzatuvchi',
  },
  theme: {
    light: 'Yorug‘',
    dark: 'Qorongʻi',
    system: 'Tizim',
  },
  table: {
    empty: 'Maʻlumot topilmadi.',
    columns: 'Ustunlar',
    density: 'Zichlik',
    previous: 'Oldingi',
    next: 'Keyingi',
    clearFilters: 'Filtrlarni tozalash',
    range: 'Jami {total} tadan {start}–{end}',
  },
  currency: {
    UZS: 'soʻm',
  },
  validation: {
    invalidNumber: 'Raqam notoʻgʻri',
    lineIncomplete: 'Qator toʻliq emas: {fields}',
    exceedsStock: 'Omborda buncha yoʻq — mavjud qoldiqdan koʻp',
    fixLines: '{count} ta qator toʻliq emas yoki xato. Tuzating yoki oʻchiring.',
  },
  catalogue: {
    expiryTitle: 'Muddat ogohlantirishlari',
    expiryHint:
      'Necha kun qolganda ogohlantirilsin. Ichma-ich boʻlishi shart: qizil < sariq < kuzatuv.',
    expiryWholeDays: 'Kunlar noldan katta butun son boʻlishi kerak.',
    expiryRedBelowAmber: 'Qizil chegara sariqdan kichik boʻlishi kerak.',
    expiryAmberBelowWatch: 'Sariq chegara kuzatuvdan kichik boʻlishi kerak.',
    criticalDays: 'Qizil (kun)',
    warningDays: 'Sariq (kun)',
    watchDays: 'Kuzatuv (kun)',
    expirySaved: 'Muddat chegaralari saqlandi',
    products: 'Mahsulotlar',
    newProduct: 'Yangi mahsulot',
    editProduct: 'Mahsulotni tahrirlash',
    sku: 'Artikul',
    name: 'Nomi',
    barcode: 'Shtrix-kod',
    category: 'Kategoriya',
    baseUnit: 'Bazaviy birlik',
    baseUnitHint: 'Eng kichik sotiladigan birlik. Barcha qoldiqlar shu birlikda saqlanadi.',
    baseUnitLocked: 'Bazaviy birlikni oʻzgartirib boʻlmaydi: mahsulotda oʻram yoki harakat bor.',
    defaultSalePrice: 'Standart sotish narxi',
    minLevel: 'Minimal qoldiq',
    maxLevel: 'Maksimal qoldiq',
    shelfLife: 'Yaroqlilik muddati (kun)',
    returnableFromStore: 'Magazindan qaytarilishi mumkin',
    returnableToSupplier: 'Yetkazib beruvchiga qaytarilishi mumkin',
    note: 'Izoh',
    packaging: 'Oʻlchov birliklari va oʻram',
    packagingHint: 'Bazaviy birlik avtomatik mavjud. Bu yerga faqat oʻramlarni qoʻshing.',
    packageUnit: 'Birlik',
    packageFactor: 'Nechta bazaviy birlik',
    packageBarcode: 'Shtrix-kod',
    purchaseDefault: 'Kirim uchun standart',
    saleDefault: 'Chiqim uchun standart',
    addPackage: 'Oʻram qoʻshish',
    removePackage: 'Oʻchirish',
    packagePreview: '1 {unit} = {factor} {base}',
    units: 'Birliklar',
    categories: 'Kategoriyalar',
    currencies: 'Valyutalar',
    rates: 'Kurslar',
    warehouses: 'Omborlar',
    locations: 'Bloklar',
    warehouseName: 'Ombor nomi',
    warehouseAddress: 'Manzil',
    isDefault: 'Asosiy',
    makeDefault: 'Asosiy qilish',
    blockCode: 'Blok kodi',
    blockName: 'Blok nomi',
    addBlock: 'Blok qoʻshish',
    noBlocks: 'Bu omborda hali blok yoʻq',
    defaultHint: 'Hujjatda ombor tanlanmasa, mol shu omborga tushadi',
    code: 'Kod',
    nameUz: 'Nomi (uz)',
    nameRu: 'Nomi (ru)',
    decimalPlaces: 'Kasr xonalari',
    symbol: 'Belgi',
    isBase: 'Bazaviy',
    makeBase: 'Bazaviy qilish',
    makeBaseConfirm:
      '«{code}» bazaviy valyuta qilinsinmi? Barcha kurslar va summalar shu valyutaga nisbatan hisoblanadi.',
    rate: 'Kurs',
    effectiveDate: 'Sana',
    setRate: 'Kursni kiritish',
    parent: 'Yuqori kategoriya',
    systemUnit: 'Tizim birligi',
    importTitle: 'Excelʻdan yuklash',
    importHint: 'Avval tekshiruv (dry-run) bajariladi, keyin tasdiqlaysiz.',
    importPreview: 'Tekshirish',
    importConfirm: 'Yuklashni tasdiqlash',
    importResult: '{created} ta yaratiladi · {skipped} ta oʻtkazib yuboriladi',
    importDone: '{created} ta mahsulot yaratildi.',
    importRow: '{row}-qator',
  },
  parties: {
    storeStatus: {
      PENDING: 'Tasdiq kutilmoqda',
      ACTIVE: 'Faol',
      CLOSED: 'Yopilgan',
    },
    allStatuses: 'Barcha holatlar',
    visitEvery: 'Tashrif davri, kun',
    visitEveryHint: 'Boʻsh qoldirsangiz — umumiy meʻyor (Sozlamalar → Agent nazorati)',
    location: 'Joylashuv',
    locationHint:
      'Google Maps yoki OpenStreetMap havolasini joylashtiring, yoki koordinatani: 41.311081, 69.240562',
    locationNow: 'Hozirgi belgi',
    locationMissing: 'Bu magazin hali xaritada belgilanmagan.',
    locationCheck: 'Xaritada tekshiring',
    locationUnreadable: 'Bu havoladan koordinata oʻqib boʻlmadi.',
    locationShortLink:
      'Qisqartirilgan havolada koordinata yoʻq. Google Mapsʻda joyni bosib turing — koordinata chiqadi, oʻshani nusxalang.',
    locationReplacesAgent: 'Diqqat: agent qoʻygan belgi almashtiriladi.',
    placedByAgent: 'Agent qoʻygan',
    placedByOffice: 'Ofis qoʻygan',
    confirmStore: 'Tasdiqlash',
    storeConfirmed: '“{name}” tasdiqlandi',
    openedByAgent: 'Agent qoʻshgan',
    onMap: 'Xaritada',
    rating: 'Reyting',
    ratingLabel: 'Toʻlov reytingi: {stars} / 5',
    lateCount: '{count} marta kechiktirgan',
    relocationPending: 'Koʻchgan deb xabar berilgan',
    relocationTitle: 'Agent: magazin koʻchgan',
    relocationDistance: 'Avvalgi joydan {m} m',
    relocationAccuracy: 'GPS aniqligi: ±{m} m',
    relocationAccept: 'Qabul qilish',
    relocationReject: 'Rad etish',
    relocationRejectConfirm: 'Xabar rad etilsinmi? Magazin joyi oʻzgarmaydi.',
    relocationAccepted: 'Magazin joyi yangilandi',
    relocationRejected: 'Xabar rad etildi',
    agentStatus: {
      ACTIVE: 'Faol',
      BLOCKED: 'Bloklangan',
      FIRED: 'Ishdan ketgan',
    },
    assignmentReason: {
      INITIAL: 'Boshlangʻich',
      FIRED: 'Ishdan ketdi',
      REDISTRIBUTION: 'Qayta taqsimlash',
      PERFORMANCE: 'Samaradorlik',
      VACATION: 'Taʻtil',
    },
    changeStatus: 'Holatni oʻzgartirish',
    statusReason: 'Sabab',
    statusReasonHint: 'Nega bu odam roundan chiqyapti — uch oydan keyin shu yozuv javob beradi.',
    statusChanged: 'Holat oʻzgartirildi',
    transfer: 'Magazinlarni koʻchirish',
    transferTo: 'Kimga',
    transferDate: 'Qaysi sanadan',
    transferNote: 'Izoh',
    transferStores: 'Koʻchiriladigan magazinlar',
    transferSummary: '{count} ta magazin → {agent}',
    transferred: '{count} ta magazin koʻchirildi',
    noStoresToTransfer: 'Bu agentda magazin yoʻq.',
    selectAll: 'Hammasini belgilash',
    agentHistory: 'Agent tarixi',
    roundHistory: 'Magazinlar tarixi',
    since: 'Sanadan',
    until: 'Sanagacha',
    currentAssignment: 'Hozirgi',
    store: 'Magazin',
    suppliers: 'Yetkazib beruvchilar',
    agents: 'Agentlar',
    stores: 'Magazinlar',
    newSupplier: 'Yangi yetkazib beruvchi',
    newAgent: 'Yangi agent',
    newStore: 'Yangi magazin',
    code: 'Kod',
    fullName: 'F.I.O.',
    name: 'Nomi',
    phone: 'Telefon',
    phoneSecondary: 'Qoʻshimcha telefon',
    address: 'Manzil',
    agent: 'Agent',
    pickUser: 'Foydalanuvchini tanlang',
    nameFromAccount:
      'Ism va telefon hisobdan olinadi. Oʻzgartirish uchun Foydalanuvchilar boʻlimidan tahrirlang.',
    creditLimit: 'Kredit limiti',
    openingBalance: 'Boshlangʻich qarz',
    openingBalanceHint: 'Qogʻozdagi qarz. Balanslar Phase 5 dan boshlab shu asosda hisoblanadi.',
    storeCount: 'Doʻkonlar soni',
    note: 'Izoh',
  },
  warehouse: {
    margin: 'Marja',
    updateCatalogue: 'Mahsulot narxini ham yangilash',
    draftSaved: 'Qoralama saqlandi',
    postedToast: '{number} tasdiqlandi',
    receipts: 'Kirim',
    newReceipt: 'Yangi kirim',
    editReceipt: 'Kirimni tahrirlash',
    stock: 'Qoldiqlar',
    docNumber: 'Hujjat №',
    batch: 'Partiya',
    date: 'Sana',
    supplier: 'Yetkazib beruvchi',
    lines: 'Pozitsiyalar',
    totalAmount: 'Umumiy summa',
    currency: 'Valyuta',
    status: 'Holat',
    createdBy: 'Yaratdi',
    product: 'Mahsulot',
    quantity: 'Soni',
    unit: 'Oʻlchov birligi',
    unitConversion: '{entered} = {base}',
    purchasePrice: 'Olish narxi',
    salePrice: 'Sotish narxi',
    perBase: '{price} / {unit}',
    productionDate: 'Ishlab chiqarilgan',
    expiryDate: 'Yaroqlilik sanasi',
    expiryEstimated: 'Taxminiy — qadoqdagi sana kiritilmagan',
    warehouseLabel: 'Ombor',
    block: 'Blok',
    blockNone: 'Bloksiz',
    lineTotal: 'Qator summasi',
    addLine: 'Qator qoʻshish',
    removeLine: 'Oʻchirish',
    duplicateLine: 'Nusxalash',
    conversionHint: '{quantity} {unit} = {base} {baseUnit}',
    saveDraft: 'Qoralama sifatida saqlash',
    post: 'Tasdiqlash',
    postConfirm: 'Tasdiqlashdan keyin omborga {total} qoʻshiladi. Hujjatni oʻzgartirib boʻlmaydi.',
    cancelDoc: 'Bekor qilish',
    cancelDocument: 'Hujjatni bekor qilish',
    chooseProductFirst: 'Avval mahsulotni tanlang',
    cancelReason: 'Bekor qilish sababi',
    cancelHint: 'Sabab majburiy. Hujjat oʻchirilmaydi — teskari yozuvlar yaratiladi.',
    totalQuantity: 'Jami miqdor',
    potentialMargin: 'Kutilayotgan foyda',
    batches: 'Partiyalar',
    movements: 'Ombor harakati',
    audit: 'Audit',
    batchNumber: 'Partiya №',
    received: 'Kelgan',
    remaining: 'Qolgan',
    allWarehouses: 'Hammasi',
    moveToBlock: 'Blokka koʻchirish',
    blockMoved: 'Partiya {code} blokiga koʻchirildi',
    movementType: 'Turi',
    occurredAt: 'Sana',
    unitCost: 'Tannarx',
    quantityOnHand: 'Qoldiq',
    reserved: 'Band',
    available: 'Mavjud',
    stockValue: 'Tannarx qiymati',
    batchCount: 'Partiyalar soni',
    nearestExpiry: 'Eng yaqin yaroqlilik',
    level: 'Holat',
    daysLeft: '{days} kun qoldi',
    expiredDays: '{days} kun oʻtgan',
    noExpiry: 'Muddatsiz',
    scanHint: 'Nom, artikul yoki shtrix-kod',
    emptyReceipts: 'Hali kirim yoʻq. Birinchi kirimni yarating.',
    emptyStock: 'Omborda hali mahsulot yoʻq.',
  },
  docStatus: {
    DRAFT: 'Qoralama',
    POSTED: 'Tasdiqlangan',
    CANCELLED: 'Bekor qilingan',
  },
  movementType: {
    RECEIPT: 'Kirim',
    SHIPMENT: 'Chiqim',
    RETURN_IN: 'Qaytarish (kirim)',
    RETURN_OUT: 'Qaytarish (chiqim)',
    WRITE_OFF: 'Hisobdan chiqarish',
    ADJUSTMENT: 'Tuzatish',
    REVERSAL: 'Teskari yozuv',
  },
  stockLevel: {
    OUT: 'Tugagan',
    LOW: 'Kam qoldi',
    NORMAL: 'Yetarli',
    OVER: 'Ortiqcha',
  },
  expiry: {
    EXPIRED: 'Muddati oʻtgan',
    CRITICAL: 'Juda yaqin',
    WARNING: 'Yaqinlashmoqda',
    WATCH: 'Kuzatuvda',
    OK: 'Yaxshi',
  },
  writeOff: {
    title: 'Hisobdan chiqarish',
    new: 'Yangi hisobdan chiqarish',
    empty: 'Hisobdan chiqarilgan mol yoʻq',
    reasonLabel: 'Sabab',
    reason: {
      EXPIRED: 'Muddati oʻtgan',
      DAMAGED: 'Shikastlangan',
      LOST: 'Yoʻqolgan',
      INTERNAL: 'Ichki ehtiyoj',
      OTHER: 'Boshqa',
    },
    loss: 'Yoʻqotish summasi',
    issuedTo: 'Kimga berildi',
    issuedToStaff: 'Xodim',
    issuedToStaffHint: 'Roʻyxatdan tanlang — shunda qarzi va oyligi bir joyda koʻrinadi',
    issuedToStaffPlaceholder: 'Xodim tanlang',
    asDebt: 'Qarzga berildi',
    asDebtHint:
      'Tovar tannarxi shu odamning qarziga yoziladi va oylikdan ushlab qolish mumkin. Belgilanmasa — korxona hisobidan (ehson).',
    issuedToHint:
      'Ism yoki boʻlim: «Direktor — uyga», «Ofis», «Haydovchi Alisher». Bu majburiy — egasiz rasxod hisobda tushuntirib boʻlmaydigan yoʻqotish boʻlib qoladi.',
    unitCost: 'Tannarx',
    batchHint: 'Qaysi partiya buzilganini oʻzingiz tanlaysiz — tizim tanlamaydi.',
    draftHint: 'Avval qoralama saqlanadi. Tasdiqlangunicha ombordan hech narsa yechilmaydi.',
    posted: '{number} tasdiqlandi',
    cancelled: 'Hisobdan chiqarish bekor qilindi',
    cancelHint: 'Mol oʻz partiyasiga, oʻz muddati bilan qaytadi.',
  },
  return: {
    quarantine: 'Karantin',
    quarantineHint:
      'Magazindan qaytgan mol shu yerda turadi: omborda bor, lekin sotilmaydi. Koʻrib chiqing va uch yoʻldan birini tanlang.',
    quarantineEmpty: 'Karantinda mol yoʻq.',
    backOnSale: 'Qayta sotuvga',
    restocked: 'Mol qayta sotuvga chiqarildi',
    title: 'Qaytarishlar',
    new: 'Yangi qaytarish',
    empty: 'Qaytarish yoʻq',
    directionLabel: 'Yoʻnalish',
    direction: {
      FROM_STORE: 'Magazindan',
      TO_SUPPLIER: 'Yetkazib beruvchiga',
    },
    party: 'Kontragent',
    unitPrice: 'Narxi',
    perBaseHint: '1 {unit} = {price}',
    batchHint: 'Qaytgan mol oʻz partiyasiga, oʻz muddati bilan qaytadi.',
    posted: '{number} tasdiqlandi',
    cancelled: 'Qaytarish bekor qilindi',
    cancelHint: 'Ombor va qarz birga qaytariladi. Ikkala hujjat ham tarixda qoladi.',
    override: 'Chegaradan oʻtkazish',
    overrideHint:
      'Doʻkon bu partiyadan olgan miqdordan koʻp qaytaryapti. Faqat direktor sabab yozib oʻtkaza oladi va bu audit jurnaliga tushadi. Mol yangi partiya sifatida kiritiladi.',
  },
  adjustment: {
    title: 'Tuzatishlar',
    subtitle: 'Inventarizatsiya farqi. Faqat direktor, sabab bilan.',
    new: 'Yangi tuzatish',
    empty: 'Tuzatish yoʻq',
    delta: 'Farq',
    deltaHint: 'Manfiy son kamaytiradi, musbat son koʻpaytiradi. Masalan: -3',
    reasonHint: 'Kamida 5 belgi. Bu raqam keyin shu sabab bilan tushuntiriladi.',
    posted: '{number} yozildi',
  },
  kpi: {
    title: 'KPI',
    metricLabel: 'Koʻrsatkich',
    deleteConfirm: 'Reja oʻchirilsinmi? Uning barcha oylik boʻlinmalari ham oʻchadi.',
    collapse: 'Yopish',
    expand: 'Ochish',
    yearTarget: 'Yillik reja',
    setTarget: 'Reja qoʻyish',
    weight: 'Vazn',
    weightHint:
      'Oylik KPI bahosida bu koʻrsatkich qanchalik hisobga olinadi; har bir koʻrsatkich 100 % da kesiladi',
    target: 'Reja',
    fact: 'Bajarildi',
    percent: 'Foiz',
    split: 'Oylarga boʻlish',
    empty: 'Reja qoʻyilmagan.',
    half: '{index}-yarim yillik',
    quarter: '{index}-chorak',
    metric: {
      SHIPPED: 'Joʻnatilgan summa',
      COLLECTED: 'Undirilgan pul',
      COLLECTION_RATE: 'Undirish foizi',
      NEW_STORES: 'Yangi magazinlar',
      VISITS: 'Tashriflar',
      ACTIVE_STORES: 'Faol magazinlar',
      OVERDUE_DEBT: 'Muddati oʻtgan qarz',
    },
    month: {
      1: 'Yanvar',
      2: 'Fevral',
      3: 'Mart',
      4: 'Aprel',
      5: 'May',
      6: 'Iyun',
      7: 'Iyul',
      8: 'Avgust',
      9: 'Sentabr',
      10: 'Oktabr',
      11: 'Noyabr',
      12: 'Dekabr',
    },
  },
  salary: {
    title: 'Oylik hisobi',
    newScheme: 'Sxema qoʻshish',
    editScheme: 'Sxemani oʻzgartirish',
    noScheme: 'Bu xodim uchun sxema yozilmagan.',
    validFrom: 'Qaysi sanadan',
    validFromHint: 'Shu sanadan keyingi oyliklar shu sxema boʻyicha hisoblanadi',
    payable: 'Jami (avanssiz)',
    apply: 'Shu raqamlarni qoʻyish',
    overdueInfoTitle: 'Muddati oʻtgan qarzlar — maʻlumot uchun, rahbar qaror qiladi',
    field: {
      base_salary: 'Asosiy oylik',
      sales_pct: 'Sotuvdan, %',
      collection_pct: 'Undirilgan puldan, %',
      new_store_bonus: 'Har yangi magazin uchun',
      kpi_bonus: 'KPI mukofoti',
      kpi_bonus_min_pct: 'KPI mukofoti uchun eng kam, %',
      visit_min_pct: 'Tashrif rejasining eng kami, %',
      visit_penalty: 'Tashrif jarimasi',
    },
    line: {
      base: 'Asosiy oylik',
      sales: 'Sotuvdan mukofot',
      collection: 'Undirilgan puldan mukofot',
      newStores: 'Yangi magazinlar uchun',
      kpi: 'KPI mukofoti',
      visitPenalty: 'Tashrif rejasi bajarilmadi',
      overdueInfo: 'Muddati oʻtgan qarz',
    },
    basis: {
      amount: 'Summa',
      pct: 'Foiz',
      count: 'Soni',
      each: 'Har biri',
      average: 'Oʻrtacha',
      minimum: 'Eng kam',
      done: 'Bajarildi',
      returned: 'Qaytarilgan',
      store: 'Doʻkon',
      days: '{n} kun',
    },
  },
  settings: {
    field: {
      tab: 'Agent nazorati',
      title: 'Agent nazorati sozlamalari',
      lede: 'Agentning aylanishi shu sozlamalar bilan oʻlchanadi. Oʻzgartirilsa, keyingi ekran yangilanishida darhol ishlaydi — hech qanday raqam qaytadan hisoblanmaydi.',
      radius: 'Magazin radiusi, metr',
      radiusHint:
        'Shu doira ichida yozilgan buyurtma «magazinda yozilgan» hisoblanadi. Telefon aniqligi ustiga qoʻshiladi (eng koʻpi 50 m)',
      overdueDays: 'Unutilgan magazin, kun',
      overdueHint: 'Shuncha kundan beri borilmagan magazin «unutilgan» roʻyxatiga tushadi',
      newLimit: 'Yangi magazin krediti',
      newLimitHint:
        'Agent botdan ochgan magazin shu limit bilan boshlaydi — nasiya qarori eshik oldida qabul qilinmaydi',
      blocks: 'Uzoqdan yozilgan buyurtmani rad etish',
      blocksHint:
        'Hozir oʻchirilgan: buyurtma oʻtadi, faqat «uzoqdan yozilgan» deb belgilanadi. Yoqsangiz, radiusdan tashqaridagi buyurtma umuman oʻtmaydi — GPS yomon ishlagan kunda agent ishlay olmaydi. Ozod qilingan agentlar bundan mustasno.',
      wholeNumbers:
        'Radius, kunlar va GPS aniqligi butun son boʻlishi va noldan katta boʻlishi kerak.',
      maxAccuracy: 'GPS aniqligi chegarasi, metr',
      maxAccuracyHint:
        'Agent magazin joyini belgilaganda telefon aniqligi shundan yomon boʻlsa, rad etiladi. Egasining qarori: 20 m — eshik oldida, koʻcha narigi tomonida emas',
      newStoreBonus: 'Yangi magazin uchun toʻlovni hisoblash',
      newStoreBonusHint:
        'Yoqilsa, oylik sxemasidagi «har yangi magazin uchun» summasi ofis tasdiqlagan oyda hisoblanadi. Hozircha oʻchirilgan',
      saved: 'Sozlamalar saqlandi',
    },
  },
  supervision: {
    title: 'Nazorat',
    subtitle: 'Agentlar bugun qayerda boʻlgan',
    today: 'Bugungi tashriflar',
    overdue: 'Unutilgan magazinlar',
    anomalies: 'Shubhali',
    at: 'Vaqti',
    day: 'Sana',
    distance: 'Masofa',
    outcome: 'Natija',
    metres: '{distance} m',
    orders: '{count} ta buyurtma',
    nothingCameOfIt: 'Buyurtma boʻlmadi',
    lastSeen: 'Oxirgi tashrif',
    daysAgo: 'Necha kun boʻldi',
    daysOf: '{days} kun (meʻyor: {of})',
    neverVisited: 'Hech qachon borilmagan',
    storeCount: 'Magazinlar',
    storesInAMinute: 'Bir daqiqada {count} ta magazin',
    noVisits: 'Bu kuni tashrif yozilmagan.',
    noOverdue: 'Unutilgan magazin yoʻq.',
    noAnomalies: 'Shubhali tashrif yoʻq.',
    reason: {
      CLOSED: 'Yopiq edi',
      NO_NEED: 'Mol kerak emas',
      NO_MONEY: 'Puli yoʻq',
      OWNER_AWAY: 'Egasi yoʻq edi',
      OTHER: 'Boshqa sabab',
    },
  },
  order: {
    waitingTitle: 'Javob kutayotgan soʻrovlar: {count}',
    confirm: 'Tasdiqlash',
    confirmed: 'Buyurtma tasdiqlandi — mol ajratildi',
    title: 'Buyurtmalar',
    new: 'Yangi buyurtma',
    edit: 'Buyurtmani tahrirlash',
    empty: 'Buyurtma yoʻq',
    openOnly: 'Javob kutayotganlar',
    offSite: 'Magazindan uzoqda yozilgan',
    offSiteOnly: 'Faqat uzoqdan yozilganlar',
    writtenAtShop: 'Magazinda yozilgan',
    metresAway: '{distance} m uzoqda',
    whereWritten: 'Qayerda yozilgan',
    notMeasured: 'Oʻlchanmagan',
    allOrders: 'Barchasi',
    available: 'Mumkin',
    reserved: 'Band',
    expectedDate: 'Kutilayotgan sana',
    overAvailable: 'Koʻpi bilan {available} ta buyurtma berish mumkin',
    accept: 'Qabul qilish',
    accepted: 'Buyurtma qabul qilindi',
    reject: 'Rad etish',
    closed: 'Buyurtma yopildi',
    closeHint:
      'Sabab doʻkonga aytiladi va hujjatda qoladi. Buyurtma oʻchmaydi — yopiladi va band qilingan mol boʻshaydi.',
    makeShipment: 'Chiqim yasash',
    shipmentMade: 'Chiqim',
    formHint:
      'Buyurtma omborni oʻzgartirmaydi. U faqat soʻrov — mol chiqim tasdiqlangandagina ketadi.',
    status: {
      REQUESTED: 'Soʻrov',
      NEW: 'Yangi',
      ACCEPTED: 'Qabul qilingan',
      FULFILLED: 'Bajarilgan',
      REJECTED: 'Rad etilgan',
      CANCELLED: 'Bekor qilingan',
      EXPIRED: 'Muddati oʻtgan',
    },
  },
  expense: {
    title: 'Xarajatlar',
    subtitle: 'Ijara, kommunal, taʻmirlash — mol bilan bogʻliq boʻlmagan pul chiqimi',
    new: 'Yangi xarajat',
    empty: 'Xarajat yoʻq',
    month: 'Oy',
    newAdvance: 'Avans berish',
    allKinds: 'Hammasi',
    staff: '(xodim)',
    staffPayee: 'Xodim',
    staffPayeeHint: 'Roʻyxatdan tanlang — keyin shu odam boʻyicha filtr qilish mumkin',
    salaryPayeeHint: 'Oylik uchun xodim majburiy — pul kimga berilganini tizim bilishi kerak',
    advanceHint:
      'Bu avans sifatida yoziladi: Oyliklar boʻlimida shu odamning oyligidan avtomatik ayiriladi.',
    staffPlaceholder: 'Xodim tanlang (ixtiyoriy)',
    category: 'Turkum',
    paidTo: 'Kimga toʻlandi',
    paidToHint: 'Ofis egasi, Hududgaz, usta — ism yoki tashkilot nomi',
    totalSpent: 'Jami sarflandi',
    recorded: '{number} yozildi',
    notAPaymentHint:
      'Diqqat: yetkazib beruvchiga MOL uchun toʻlov bu yerga yozilmaydi — u «Kassa» boʻlimida. Uni ikki marta yozsangiz, foyda ikki barobar kam koʻrinadi.',
  },
  payroll: {
    title: 'Oyliklar',
    subtitle: 'Har bir xodimga alohida: asosiy oylik, mukofot va qarzdan ushlash',
    employees: 'Xodimlar',
    newEmployee: 'Yangi xodim',
    employee: 'Xodim',
    position: 'Lavozim',
    baseSalary: 'Asosiy oylik',
    owes: 'Qarzi',
    owesHint:
      'Bu xodim {amount} qarzdor. Ushlab qolish shart emas — keyingi oyga qoldirsa ham boʻladi.',
    paidOut: 'Berildi',
    pay: 'Oylik berish',
    finish: 'Davom ettirish',
    paid: '{number} toʻlandi',
    done: 'Berilgan',
    empty: 'Xodim yoʻq',
    monthTotal: 'Oy boʻyicha',
    bonus: 'Mukofot',
    bonusNote: 'Mukofot izohi',
    deduction: 'Qarzdan ushlash',
    advance: 'Avans',
    overAdvanced: 'Bu oyda berilgan avans ishlab topilganidan koʻp',
    tooMuch: 'Qarzdan koʻp ushlab boʻlmaydi',
    net: 'Qoʻlga tegadi',
    earnedHint:
      'Xarajatga asosiy + mukofot yoziladi — xodim shuncha topdi. Ushlab qolingan summa qarzni yopadi, kassadan esa qolgani chiqadi.',
    scoreTitle: 'Mukofot uchun — shu agentning koʻrsatkichlari',
    shipped: 'Joʻnatgan',
    collected: 'Undirgan',
    outstanding: 'Qolgan qarz',
    overdue90: '90+ kunlik',
    agentHint: 'Agent tanlansa, oylik berishda uning undirish koʻrsatkichlari chiqadi.',
  },
  shipment: {
    postedToast: '{number} tasdiqlandi',
    title: 'Chiqim',
    newShipment: 'Yangi chiqim',
    editShipment: 'Chiqimni tahrirlash',
    store: 'Magazin',
    agent: 'Agent',
    dueDate: 'Toʻlov muddati',
    duePresets: '7 kun / 14 kun / 30 kun',
    balance: 'Joriy qarz',
    creditLimit: 'Kredit limiti',
    headroom: 'Qolgan boʻshliq',
    noLimit: 'Limitsiz',
    projected: 'Chiqimdan keyin',
    available: 'Mavjud',
    availableBatches: 'Mavjud partiyalar',
    fromWarehouse: 'Qaysi ombordan',
    anyWarehouse: 'Istalgan ombordan',
    pinWarehouse: 'Faqat shu ombordan',
    allocations: 'Partiyalar boʻyicha',
    allocation: 'Qaysi partiyadan',
    cogs: 'Tannarx',
    margin: 'Foyda',
    marginPercent: 'Foyda %',
    unitChanged: 'Birlik oʻzgardi — narx qayta hisoblandi',
    allowExpired: 'Muddati oʻtgan partiyalarni ham ishlatish',
    overrideCreditLimit: 'Kredit limitidan oshishga ruxsat',
    adminOnly: 'Faqat direktor',
    overdueOnly: 'Muddati oʻtganlar',
    postConfirm:
      'Tasdiqlashdan keyin {count} pozitsiya ombordan chiqadi va {store} qarzi {total} ga ortadi.',
    emptyShipments: 'Hali chiqim yoʻq. Birinchi chiqimni yarating.',
    print: 'Chop etish',
    deliveryNote: 'Yuk xati',
    warnings: 'Ogohlantirishlar',
  },
  warn: {
    near_expiry: '{batch} partiyasining yaroqlilik muddatiga {days_left} kun qoldi.',
    expired_skipped:
      '{product}: muddati oʻtgan {count} ta partiya ({quantity}) oʻtkazib yuborildi — ularni hisobdan chiqarish kerak.',
    credit_limit_overridden:
      '{store} kredit limitidan ({limit}) oshdi — {projected}. Ruxsat berdi: {by}.',
  },
  finance: {
    shipped: 'Joʻnatilgan',
    collected: 'Undirilgan',
    balance: 'Qarzi',
    supplier: 'Yetkazib beruvchi',
    store: 'Magazin',
    agent: 'Agent',
    party: 'Kontragent',
    goodsReceived: 'Olingan mahsulotlar',
    goodsShipped: 'Berilgan mahsulotlar',
    paymentsGiven: 'Berilgan toʻlovlar',
    documentsCount: '{count} hujjat',
    paymentsCount: '{count} toʻlov',
    theyOweUs: 'Bizga qarz',
    weOweThem: 'Bizning qarzimiz',
    settled: 'Qarz yoʻq',
    lastMovement: 'Oxirgi harakat',
    amount: 'Pul miqdori',
    methodLabel: 'Toʻlov turi',
    paidAt: 'Sana',
    paidOn: 'Toʻlangan kuni',
    comment: 'Izoh',
    commentHint: 'Ixtiyoriy',
    balanceBefore: 'Qoldiq (oldin)',
    balanceAfter: 'Qoldiq (keyin)',
    recordPayment: 'Toʻlovni saqlash',
    cancelPayment: 'Toʻlovni bekor qilish',
    cancelReason: 'Bekor qilish sababi',
    cancelReasonHint: 'Masalan: ikki marta kiritildi',
    docNumber: 'Hujjat №',
    date: 'Sana',
    document: 'Hujjat',
    note: 'Izoh',
    debit: 'Debet',
    credit: 'Kredit',
    runningBalance: 'Qoldiq',
    openingBalance: 'Boshlangʻich qoldiq',
    oldestIsOpening: 'Boshlangʻich qoldiq',
    closingBalance: 'Yakuniy qoldiq',
    dateFrom: 'Sanadan',
    dateTo: 'Sanagacha',
    exportExcel: 'Excel',
    direction: 'Yoʻnalish',
    incoming: 'Kirim',
    outgoing: 'Chiqim',
    paymentIn: 'Pul keldi',
    paymentOut: 'Pul ketdi',
    allDirections: 'Barchasi',
    allMethods: 'Barcha turlar',
    total: 'Jami',
    totalQuantity: 'Jami miqdor',
    averagePrice: 'Oʻrtacha narx',
    lastPrice: 'Oxirgi narx',
    lastPurchase: 'Oxirgi kirim',
    shippedTotal: 'Jami chiqim',
    collectedTotal: 'Yigʻilgan toʻlovlar',
    exposure: 'Qoldiq qarz',
    storesServed: 'Doʻkonlar',
    debt: 'Qarz',
    oldestUnpaid: 'Toʻlanmagan eng eski hujjat',
    daysOverdue: 'Kechikkan kun',
    collectionRate: 'Yigʻish darajasi',
    averageCollectionDays: 'Oʻrtacha yigʻish muddati (kun)',
    payToSupplier: 'Yetkazib beruvchiga toʻlov',
    collectFromStore: 'Magazindan toʻlov',
    chooseSupplier: 'Yetkazib beruvchini tanlang',
    chooseSupplierFirst: 'Avval yetkazib beruvchini tanlang.',
    collectedFrom: 'Qaysi magazindan',
    chooseStore: 'Magazinni tanlang',
    chooseStoreFirst: 'Avval magazinni tanlang — pul har doim magazinning qarziga yoziladi.',
    documentsCountShort: 'Hujjatlar',
    receivablesAging: 'Qarzdorlik yoshi',
    method: {
      CASH: 'Naqd',
      CLICK: 'Click',
      TRANSFER: 'Oʻtkazma',
      CARD: 'Karta',
    },
    docType: {
      goods_receipt: 'Kirim',
      shipment: 'Chiqim',
      payment: 'Toʻlov',
      OPENING: 'Boshlangʻich qoldiq',
    },
    aging: {
      not_due: 'Muddati kelmagan',
      d1_30: '1–30 kun',
      d31_60: '31–60 kun',
      d61_90: '61–90 kun',
      d90_plus: '90+ kun',
    },
    tab: {
      receipts: 'Kirimlar',
      shipments: 'Chiqimlar',
      payments: 'Toʻlovlar',
      kassa: 'Kassa',
      statement: 'Hisobot',
      products: 'Mahsulotlar',
      stores: 'Doʻkonlar',
      performance: 'Samaradorlik',
    },
  },
  goLive: {
    title: 'Tizimga oʻtish',
    intro:
      'Qogʻozdagi qoldiq va qarzlar tizimga hujjat sifatida kiritiladi. Qulflashdan oldin uch summani qogʻozdagi yozuvlaringiz bilan solishtiring.',
    step1: '1-qadam · Sanani belgilash',
    step2: '2-qadam · Yakuniy tekshiruv',
    step3: '3-qadam · Qulflash',
    dateLabel: 'Oʻtish sanasi',
    saveDate: 'Saqlash',
    openingStock: 'Boshlangʻich qoldiq qiymati',
    stockDetail: '{batches} partiya · {products} mahsulot',
    totalReceivable: 'Bizga qarz (magazinlar)',
    totalPayable: 'Bizning qarzimiz (yetkazib beruvchilar)',
    storesCount: '{count} magazin',
    suppliersCount: '{count} yetkazib beruvchi',
    lockHint:
      'Qulflagandan keyin boshlangʻich hujjatlarni faqat direktor oʻzgartira oladi. Tasdiqlash uchun ikki summani qoʻlda yozing.',
    confirmReceivable: 'Bizga qarz summasini yozing',
    confirmPayable: 'Bizning qarzimiz summasini yozing',
    lockButton: 'Qulflash',
    locked: 'Tizimga oʻtish {date} sanasida qulflangan.',
  },
  dashboard: {
    vsPreviousPeriod: 'Oʻtgan shu davrga nisbatan',
    openList: 'Roʻyxatni ochish',
    overdue90: '90+ kun',
    inQuarantine: 'Shundan karantinda',
    valueAtRisk: 'Xavf ostidagi qiymat',
    daysLeft: 'Qolgan kun',
    daysCounted: '{count} kun',
    goodsIn: 'Kirim',
    goodsOut: 'Chiqim',
    revenue: 'Tushum',
    cogs: 'Tannarx',
    grossProfit: 'Yalpi foyda',
    margin: 'Marja',
    deadStock: 'Harakatsiz',
    period: {
      today: 'Bugun',
      week: '7 kun',
      month: '30 kun',
      quarter: 'Chorak',
      year: 'Yil',
      custom: 'Oraliq',
    },
    measure: { amount: 'Summa', quantity: 'Miqdor' },
    kpi: {
      stock_value: 'Ombor qiymati',
      receivable: 'Bizga qarz',
      payable: 'Bizning qarzimiz',
      net_position: 'Sof pozitsiya',
      period_in: 'Kirim',
      period_out: 'Chiqim',
    },
    otherCosts: 'Ichki rasxod va yoʻqotish',
    openOrders: 'Ochiq buyurtmalar',
    orderValue: 'Buyurtmalar summasi',
    awaitingAnswer: 'Javob kutmoqda',
    reservedProducts: '{count} mahsulot boʻyicha zaxira band',
    monthWages: 'Shu oy oyliklari',
    paidSoFar: 'Berildi',
    staffDebt: 'Xodimlar qarzi',
    staffDebtHint: 'Qarzga olingan tovar — oylikdan ushlab qolinsa yopiladi',
    card: {
      expiry: 'Yaroqlilik muddati',
      lowStock: 'Kam qolgan mahsulotlar',
      overstock: 'Ortiqcha zaxira',
      dynamics: 'Kirim/Chiqim dinamikasi',
      storeDebt: 'Doʻkonlar qarzdorligi',
      agentDebt: 'Agentlar boʻyicha qarz',
      topProducts: 'Top mahsulotlar',
      profit: 'Foyda',
      orders: 'Buyurtmalar',
      staff: 'Xodimlar kassasi',
      overdue: 'Muddati oʻtgan toʻlovlar',
      turnover: 'Aylanma tezligi',
      activity: 'Soʻnggi harakatlar',
      collection: 'Pul yigʻilishi',
      overLimit: 'Kredit limitidan oshganlar',
      dormant: 'Uxlab qolgan magazinlar',
      fillRate: 'Buyurtma bajarilishi',
      frozen: 'Muzlagan pul',
    },
    collected: 'yigʻildi',
    shippedOnCredit: 'Nasiyaga chiqarildi',
    cameToKassa: 'Kassaga tushdi',
    notYetCollected: 'Shu davrda yigʻilmagani',
    outstandingAll: 'Umumiy qarz (barcha davr)',
    overLimitHint: 'Bu magazinlarga yangi chiqim toʻxtatilishi kerak',
    nobodyOverLimit: 'Hech kim limitdan oshmagan.',
    overBy: 'Oshgani',
    dormantHint: '{days} kundan beri buyurtma yoʻq',
    everybodyBuying: 'Barcha magazinlar faol.',
    lastOrder: 'Oxirgi chiqim',
    quietFor: 'Jimlik',
    lastYearValue: 'Yillik savdosi',
    days: '{n} kun',
    fillRateHint: 'Soʻralgan va joʻnatilgan',
    noOrdersInPeriod: 'Bu davrda buyurtma boʻlmagan.',
    ofOrders: '{all} tadan {done} tasi bajarildi',
    ordered: 'Soʻralgan',
    shipped: 'Joʻnatilgan',
    stillOpen: 'Ochiq: {n}',
    lost: 'Qoʻldan ketgan: {n}',
    frozenHint: '{days} kundan beri qimirlamagan',
    everythingMoving: 'Barcha mahsulot harakatda.',
    frozenTotal: 'omborda turibdi',
  },
  reports: {
    'stock-valuation': 'Ombor qiymati',
    expiry: 'Yaroqlilik muddati',
    'receivables-aging': 'Qarzdorlik yoshi',
    payables: 'Yetkazib beruvchilarga qarz',
    sales: 'Savdo',
    profit: 'Foyda',
    'net-profit': 'Sof foyda',
    averageCost: 'Oʻrtacha tannarx',
    value: 'Qiymati',
    expiryDate: 'Yaroqlilik muddati',
    bucket: 'Boʻlim',
    name: 'Nomi',
    inQuarantine: 'Shundan karantinda',
    quarantineLots: '{n} partiya',
    groupBy: {
      product: 'Mahsulot boʻyicha',
      store: 'Magazin boʻyicha',
      agent: 'Agent boʻyicha',
      month: 'Oy boʻyicha',
    },
  },
  netProfit: {
    revenue: 'Tushum',
    cogs: 'Tannarx',
    gross: 'Yalpi foyda',
    marginHint: 'marja {percent}',
    expenses: 'Xarajatlar',
    expensesHint: 'ijara, oylik, kommunal — oyliklar ham shu yerda hisoblangan',
    internal: 'Ichki rasxod',
    internalHint: 'bepul berilgani — qarzga berilgani bu yerda emas',
    losses: 'Yoʻqotishlar',
    net: 'SOF FOYDA',
    netHint: 'tushumdan {percent}',
    chargedHint: 'Xodimlarga qarzga berilgan tovar (hisobotga kirmaydi, ular qarzida turibdi):',
  },
  company: {
    title: 'Korxona maʻlumotlari',
    subtitle: 'Bosma hujjatlarda va yon panelda shu maʻlumot chiqadi. Bir marta toʻldiriladi.',
    name: 'Korxona nomi',
    nameHint: 'Qisqa nom — hujjat sarlavhasida chiqadi',
    legalName: 'Toʻliq yuridik nom',
    address: 'Manzil',
    phone: 'Telefon',
    email: 'Elektron pochta',
    taxId: 'STIR',
    bank: 'Bank rekvizitlari',
    bankName: 'Bank nomi',
    bankAccount: 'Hisob raqami',
    logo: 'Logotip',
    noLogo: 'Logotip qoʻyilmagan',
    removeLogo: 'Oʻchirish',
    logoHint: 'PNG, JPG yoki SVG. {limit} KB dan oshmasin — bu sarlavha rasmi, surat emas.',
    logoTooBig: 'Rasm juda katta. {limit} KB gacha boʻlsin.',
    saved: 'Korxona maʻlumotlari saqlandi',
  },
  palette: {
    title: 'Buyruqlar paneli',
    placeholder: 'Ekran, mahsulot, magazin yoki yetkazib beruvchi…',
    group: {
      screen: 'Ekran',
      product: 'Mahsulot',
      store: 'Magazin',
      supplier: 'Yetkazib beruvchi',
    },
  },
  shortcuts: {
    title: 'Klaviatura yorliqlari',
    global: 'Umumiy',
    documents: 'Hujjat formalari',
    tables: 'Jadvallar',
    palette: 'Buyruqlar paneli',
    sheet: 'Yorliqlar roʻyxati',
    close: 'Yopish',
    saveDraft: 'Qoralamani saqlash',
    post: 'Tasdiqlash',
    newLine: 'Yangi qator',
    moveRow: 'Qatorlar boʻylab yurish',
    openRow: 'Qatorni ochish',
  },
  print: {
    company: 'OMBOR MChJ',
    companyAddress: 'Toshkent sh., Asosiy ombor',
    counterparty: 'Kontragent',
    printedAt: 'Chop etilgan',
    receipt: 'Kirim hujjati',
    deliveryNote: 'Yetkazish varaqasi',
    statement: 'Hisob-kitob varaqasi',
    paymentReceipt: 'Toʻlov kvitansiyasi',
    signedBy: 'Topshirdi',
    receivedBy: 'Qabul qildi',
    accountant: 'Hisobchi',
  },
  errors: {
    AGENT_NOT_DISMISSABLE:
      'Ishdan chiqarib boʻlmaydi: magazinlari boshqa agentga koʻchirilmagan yoki oyligi tugallanmagan.',
    apiUnreachable: 'Server bilan aloqa yoʻq. Oʻzgarishlar saqlanmaydi.',
    title: 'Xatolik',
    INVALID_CREDENTIALS: 'Login yoki parol notoʻgʻri',
    PAYROLL_EXPENSE_LOCKED:
      'Bu xarajatni oylik vedomosti yozgan; uni alohida bekor qilib boʻlmaydi.',
    SHOP_PHONE_SHARED: 'Bu raqam bir nechta doʻkonga yozilgan. Ofisga murojaat qiling.',
    ACCOUNT_LOCKED: 'Hisob vaqtincha bloklangan. Birozdan soʻng urinib koʻring.',
    ACCOUNT_INACTIVE: 'Bu hisob nofaol qilingan. Administratorga murojaat qiling.',
    INVALID_TOKEN: 'Sessiya tugadi. Qaytadan kiring.',
    TOKEN_REUSE_DETECTED: 'Xavfsizlik sababli barcha sessiyalar tugatildi. Qaytadan kiring.',
    CSRF_FAILED: 'Soʻrov tasdiqlanmadi. Sahifani yangilang.',
    PERMISSION_DENIED: 'Bu amal uchun ruxsatingiz yoʻq.',
    PASSWORD_CHANGE_REQUIRED: 'Avval vaqtinchalik parolni oʻzgartiring.',
    CANCEL_WINDOW_CLOSED:
      'Hujjat tasdiqlanganiga 24 soatdan koʻp vaqt oʻtdi — endi uni faqat direktor bekor qila oladi.',
    CANCEL_DIRECTOR_ONLY: 'Bu hujjatni faqat direktor bekor qila oladi.',
    NOT_FOUND: 'Topilmadi.',
    CONFLICT: 'Bu maʻlumot allaqachon mavjud.',
    WEAK_PASSWORD: 'Parol talablarga javob bermaydi.',
    RATE_LIMITED: 'Juda koʻp urinish. Biroz kuting.',
    VALIDATION_ERROR: 'Maʻlumotlarda xatolik bor.',
    SERVICE_UNAVAILABLE: 'Server javob bermayapti.',
    NETWORK: 'Serverga ulanib boʻlmadi.',
    ORDER_STATE: 'Buyurtmaning hozirgi holati bu amalga ruxsat bermaydi.',
    NOT_AT_THE_SHOP: 'Siz «{store}» magazinida emassiz: masofa {distance_m} m.',
    PRICE_CHANGED: '«{product}» narxi oʻzgardi: koʻrsatilgan {shown}, hozirgi {current}.',
    KPI_PLAN_SHAPE: 'KPI reja davriga mos kelmaydi yoki boʻlaklari yigʻindiga teng emas.',
    TRANSFER_DATE_IN_FUTURE: 'Oʻtkazma sanasi kelajakda boʻlishi mumkin emas: {effective_date}.',
    TRANSFER_DATE_TOO_EARLY:
      '«{store}» hozirgi agentga {since} dan biriktirilgan; oʻtkazma sanasi undan keyin boʻlsin (eng erta: {earliest}).',
    SCHEME_MONTH_PAID:
      '{month} oyi uchun oylik allaqachon tasdiqlangan ({paid_through} gacha). Sxemani keyingi oydan yozing.',
    LOCATION_ALREADY_SET:
      '«{store}» joyi allaqachon belgilangan. Doʻkon koʻchgan boʻlsa, rahbarga xabar yuboring.',
    LOCATION_PROPOSAL_PENDING: 'Bu doʻkon uchun koʻchish xabari allaqachon kutilmoqda.',
    LOCATION_PROPOSAL_DECIDED: 'Bu xabar boʻyicha qaror allaqachon qabul qilingan ({status}).',
    LOCATION_TOO_COARSE:
      'GPS aniqligi yetarli emas ({accuracy_m} m, ruxsat etilgani {limit_m} m). Doʻkon eshigi oldida qayta yuboring.',
    PRODUCT_UNPRICED: '«{product}» uchun narx belgilanmagan — doʻkon buyurtma qila olmaydi.',
    ORDER_POSITION_REQUIRED:
      '«{store}» uchun buyurtma faqat doʻkon oldida yoziladi: joylashuvingizni yuboring.',
    OFF_SITE_ORDER:
      'Buyurtma magazindan {distance_m} m uzoqda yozilgan. Ruxsat etilgan radius: {radius_m} m.',
    NOT_ENOUGH_TO_PROMISE:
      'Buyurtma berish mumkin boʻlganidan koʻp soʻralyapti: {available} mumkin, {requested} soʻralgan.',
    INSUFFICIENT_BATCH: '«{batch}» partiyasida {available} bor, {requested} soʻralyapti.',
    RETURN_EXCEEDS_DELIVERY:
      'Bu doʻkon «{batch}» partiyasidan {delivered} olgan, {already_returned} qaytargan — yana {available} qaytara oladi, lekin {requested} soʻralyapti.',
    DOCUMENT_STATE: 'Hujjatning hozirgi holati bu amalga ruxsat bermaydi.',
    PAYMENT_STATE: 'Toʻlovning hozirgi holati bu amalga ruxsat bermaydi.',
    GO_LIVE_LOCKED: 'Tizimga oʻtish qulflangan. Oʻzgartirish faqat direktor orqali.',
    GO_LIVE_NOT_READY: 'Tizimga oʻtish hali tugallanmagan.',
    IDEMPOTENCY_CONFLICT: 'Bu soʻrov allaqachon boshqa maʻlumot bilan yuborilgan.',
    INSUFFICIENT_STOCK: 'Omborda yetarli mahsulot yoʻq.',
    CREDIT_LIMIT_EXCEEDED: 'Kredit limitidan oshadi.',
    INVALID_DOCUMENT_STATE: 'Hujjat holati bu amalga ruxsat bermaydi.',
    DOCUMENT_HAS_NO_LINES: 'Hujjatda birorta qator yoʻq.',
    BATCH_ALREADY_CONSUMED:
      'Bu mahsulotlarning bir qismi allaqachon ombordan chiqib ketgan. Avval shu hujjatlarni bekor qiling: {documents}',
    MISSING_EXCHANGE_RATE: 'Bu sana uchun valyuta kursi kiritilmagan.',
    FRACTIONAL_BASE_UNIT: 'Bu birlikda kasr son boʻlishi mumkin emas.',
    BASE_UNIT_LOCKED: 'Bazaviy birlikni oʻzgartirib boʻlmaydi.',
    ENTITY_IN_USE: 'Bu yozuv ishlatilmoqda — oʻchirib boʻlmaydi.',
    BATCH_PRODUCT_MISMATCH:
      '«{batch}» partiyasi boshqa mahsulotga tegishli. Shu mahsulotning partiyasini tanlang.',
    BATCH_BLOCKED: '«{batch}» partiyasi bekor qilingan kirimdan — unga mahsulot qoʻshib boʻlmaydi.',
    BATCH_OVER_RECEIVED:
      '«{batch}» partiyasiga {received} kelgan, hozir {remaining} bor — {requested} qoʻshilsa, kelganidan oshib ketadi. Ortiqchani yangi kirim bilan kiriting.',
    RETURNS_EXIST:
      'Doʻkon bu chiqimdagi mahsulotning bir qismini qaytargan. Avval shu qaytarishlarni bekor qiling: {documents}',
    PARTY_HAS_BALANCE:
      'Bu kontragentning qoldigʻi {balance} — hisob-kitob yopilmaguncha oʻchirib boʻlmaydi.',
    SYSTEM_ENTITY: 'Tizim yozuvi — oʻchirib boʻlmaydi.',
    DEFAULT_WAREHOUSE:
      'Asosiy omborni oʻchirib yoki bekor qilib boʻlmaydi — avval boshqasini asosiy qiling.',
    NO_STOCK_TO_REMOVE: 'Chiqarish uchun qoldiq yoʻq.',
    IMPORT_FILE_INVALID: 'Fayl oʻqilmadi.',
    ADVANCE_EXCEEDS_EARNINGS:
      'Bu oy uchun allaqachon {advance} avans berilgan — bu oylik ({earned}) undan kam.',
    AGENT_REQUIRED: 'Pulni olib kelgan agentni tanlang.',
    BASE_CURRENCY_RATE: 'Asosiy valyutaning kursi doim 1 — uni kiritib boʻlmaydi.',
    BASE_CURRENCY_REQUIRED: 'Asosiy valyuta boʻlishi shart — avval boshqa valyutani asosiy qiling.',
    BASE_UNIT_AS_PACKAGE: 'Bazaviy birlik qadoq sifatida qoʻshilmaydi — u doim 1 ga teng.',
    BATCH_SUPPLIER_MISMATCH: '«{batch}» partiyasi boshqa yetkazib beruvchidan kelgan.',
    BOT_SECRET_INVALID: 'Bot kaliti notoʻgʻri.',
    CATEGORY_OWN_PARENT: 'Kategoriya oʻziga ota-kategoriya boʻla olmaydi.',
    CONSTRAINT_VIOLATED:
      'Maʻlumotlar bazasi bu oʻzgarishni rad etdi. Sahifani yangilab, qayta urinib koʻring.',
    DEBTOR_REQUIRED: 'Qarzga berilgan mol uchun qarzdor xodimni tanlang.',
    DEDUCTION_EXCEEDS_DEBT:
      'Ushlab qolinadigan summa ({deduction}) xodimning qarzidan ({owed}) katta.',
    DEDUCTION_EXCEEDS_PAY:
      'Avanslardan keyin qolgan oylik ({remaining}) ushlab qolinadigan summadan ({deduction}) kam.',
    DEFAULT_UNIT_INVALID:
      'Asosiy birlik bazaviy birlik yoki mahsulot qadoqlaridan biri boʻlishi kerak.',
    EXPENSE_STATE: 'Xarajatning hozirgi holati bu amalga ruxsat bermaydi.',
    FOREIGN_KEY_IN_USE:
      'Bogʻliq yozuv topilmadi yoki hali ishlatilmoqda. Sahifani yangilab, qayta urinib koʻring.',
    INTERNAL_ERROR:
      'Kutilmagan xatolik yuz berdi va u qayd etildi. Muammo davom etsa, administratorga murojaat qiling.',
    INVALID_VALUE: 'Kiritilgan qiymat juda katta yoki notoʻgʻri.',
    LOCATION_RETIRED: '«{location}» bloki foydalanishdan chiqarilgan.',
    LOCATION_WRONG_WAREHOUSE: '«{location}» bloki boshqa omborga tegishli.',
    LOGO_TOO_LARGE: 'Logotip fayli juda katta.',
    OVERRIDE_REASON_REQUIRED: 'Cheklovni chetlab oʻtish sababini yozing.',
    PAYROLL_STATE: 'Oylikning hozirgi holati bu amalga ruxsat bermaydi.',
    RECIPIENT_REQUIRED: 'Ichki chiqimda molni kim olganini koʻrsating.',
    SALARY_NEEDS_A_PERSON: 'Oylik xarajati uchun xodimni tanlang.',
    SELF_DEACTIVATION: 'Oʻz hisobingizni nofaol qila olmaysiz.',
    SELF_DELETION: 'Oʻz hisobingizni oʻchira olmaysiz.',
    SELF_ROLE_CHANGE: 'Oʻz rolingizni oʻzgartira olmaysiz.',
    SHOP_ALREADY_LINKED: 'Bu Telegram hisobi boshqa doʻkonga ulangan.',
    SHOP_NOT_LINKED: 'Doʻkon Telegramga ulanmagan.',
    STORE_REQUIRED: 'Doʻkondan qaytarishda doʻkonni tanlang.',
    SUPPLIER_PAYMENT_AGENT: 'Yetkazib beruvchiga toʻlovda agent koʻrsatilmaydi.',
    SUPPLIER_REQUIRED: 'Yetkazib beruvchiga qaytarishda yetkazib beruvchini tanlang.',
    TELEGRAM_ALREADY_LINKED: 'Bu Telegram hisobi boshqa foydalanuvchiga ulangan.',
    TELEGRAM_NOT_LINKED: 'Telegram hisobi ulanmagan.',
    UNIT_LISTED_TWICE: 'Bir birlik ikki marta koʻrsatilgan.',
    UNIT_NOT_CONFIGURED: '«{product}» mahsulotida bunday oʻlchov birligi yoʻq.',
    UNKNOWN_ERROR: 'Kutilmagan xatolik yuz berdi.',
  },
  password: {
    too_short: 'Kamida 8 ta belgi boʻlishi kerak',
    too_common: 'Bu parol juda oddiy',
    contains_username: 'Parolda login boʻlmasligi kerak',
    digits_only: 'Faqat raqamlardan iborat boʻlmasligi kerak',
    mismatch: 'Parollar mos kelmadi',
  },
  pages: {
    forbidden: {
      title: 'Ruxsat yoʻq',
      message: 'Bu sahifani koʻrish uchun ruxsatingiz yoʻq.',
    },
    notFound: {
      title: 'Sahifa topilmadi',
      message: 'Soʻralgan manzil mavjud emas.',
      back: 'Bosh sahifaga qaytish',
    },
    dashboard: {
      placeholder: 'Poydevor tayyor. Modullar bosqichma-bosqich qoʻshiladi.',
      apiChecking: 'API: tekshirilmoqda…',
      apiDown: 'API: ulanmadi',
      apiUp: 'API: ishlamoqda',
    },
  },
}
